import { useLazyQuery } from "@apollo/client";
import { SHORTAGE_PRODUCTS } from "../reportTypeDefs";

export const useLazyQueryShortageProducts = (options?: any) =>
  useLazyQuery(SHORTAGE_PRODUCTS, options);
